'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TimeRange(id, starts, ends) {
  this.Em = null;
  this.u9 = null;
  this.u8 = null;
  this.Em = id;
  this.u9 = starts;
  this.u8 = ends;
}
export { $c_Lpresto_types$TimeRange as $c_Lpresto_types$TimeRange };
$p = $c_Lpresto_types$TimeRange.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TimeRange;
/** @constructor */
function $h_Lpresto_types$TimeRange() {
}
export { $h_Lpresto_types$TimeRange as $h_Lpresto_types$TimeRange };
$h_Lpresto_types$TimeRange.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$TimeRange)) {
    if ((this.Em === x$0.Em)) {
      var x = this.u9;
      var x$2 = x$0.u9;
      var $x_1 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.u8;
      var x$4 = x$0.u8;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "TimeRange";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.Em;
      break;
    }
    case 1: {
      return this.u9;
      break;
    }
    case 2: {
      return this.u8;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$TimeRange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kk)));
}
export { $isArrayOf_Lpresto_types$TimeRange as $isArrayOf_Lpresto_types$TimeRange };
var $d_Lpresto_types$TimeRange = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TimeRange, "presto.types$TimeRange", ({
  kk: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$TimeRange as $d_Lpresto_types$TimeRange };
//# sourceMappingURL=presto.types$-Time-Range.js.map
